import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronRight, Users, ClipboardCheck, CalendarClock } from 'lucide-react';
export function LineupTourOpsPage() {
  return <div className="pt-32 pb-20" data-id="element-6510">
      {/* Hero */}
      <section className="max-w-4xl mx-auto px-6 text-center mb-24" data-id="element-6511">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-5xl md:text-6xl font-bold tracking-tight mb-6 leading-tight" data-id="element-6512">
          A show isn't locked until the venue and the band are locked.
        </motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-xl text-textMuted mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-6513">
          Booker handles lineup dependencies, member availability, show
          readiness, itinerary details, and post-show payout workflow.
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} data-id="element-6514">
          <Link to="/onboarding" className="inline-flex items-center gap-2 px-8 py-4 text-base font-medium text-background bg-primary rounded-lg hover:bg-primaryHover transition-all shadow-[0_0_20px_rgba(245,158,11,0.3)]" data-id="element-6515">
            Start free
            <ChevronRight className="w-4 h-4" data-id="element-6516" />
          </Link>
        </motion.div>
      </section>

      {/* Features */}
      <section className="max-w-6xl mx-auto px-6" data-id="element-6517">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-6518">
          <div className="bg-surface border border-border rounded-xl p-8" data-id="element-6519">
            <Users className="w-8 h-8 text-primary mb-6" data-id="element-6520" />
            <h3 className="text-xl font-semibold mb-3" data-id="element-6521">Lineup Logic</h3>
            <p className="text-textMuted" data-id="element-6522">
              Define required roles, track member availability, and manage
              substitutes. Booker warns you of conflicts before you sign a
              contract.
            </p>
          </div>

          <div className="bg-surface border border-border rounded-xl p-8" data-id="element-6523">
            <ClipboardCheck className="w-8 h-8 text-primary mb-6" data-id="element-6524" />
            <h3 className="text-xl font-semibold mb-3" data-id="element-6525">Show Advance</h3>
            <p className="text-textMuted" data-id="element-6526">
              Standardized checklists for load-in, soundcheck, hospitality, and
              tech requirements ensure nothing falls through the cracks.
            </p>
          </div>

          <div className="bg-surface border border-border rounded-xl p-8" data-id="element-6527">
            <CalendarClock className="w-8 h-8 text-primary mb-6" data-id="element-6528" />
            <h3 className="text-xl font-semibold mb-3" data-id="element-6529">Itinerary & Payouts</h3>
            <p className="text-textMuted" data-id="element-6530">
              Give the road team access to the itinerary, and automatically
              calculate member payouts based on final show settlement.
            </p>
          </div>
        </div>
      </section>
    </div>;
}